// source: users.proto

/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
var jspb = require('google-protobuf');

var goog = jspb;
var global = Function('return this')();
goog.exportSymbol('proto.api.users.pb.DeleteInboxMessageRequest', null, global);
goog.exportSymbol('proto.api.users.pb.DeleteInboxMessageResponse', null, global);
goog.exportSymbol('proto.api.users.pb.DeleteSentboxMessageRequest', null, global);
goog.exportSymbol('proto.api.users.pb.DeleteSentboxMessageResponse', null, global);
goog.exportSymbol('proto.api.users.pb.GetThreadRequest', null, global);
goog.exportSymbol('proto.api.users.pb.GetThreadResponse', null, global);
goog.exportSymbol('proto.api.users.pb.ListInboxMessagesRequest', null, global);
goog.exportSymbol('proto.api.users.pb.ListInboxMessagesRequest.Status', null, global);
goog.exportSymbol('proto.api.users.pb.ListInboxMessagesResponse', null, global);
goog.exportSymbol('proto.api.users.pb.ListSentboxMessagesRequest', null, global);
goog.exportSymbol('proto.api.users.pb.ListSentboxMessagesResponse', null, global);
goog.exportSymbol('proto.api.users.pb.ListThreadsRequest', null, global);
goog.exportSymbol('proto.api.users.pb.ListThreadsResponse', null, global);
goog.exportSymbol('proto.api.users.pb.Message', null, global);
goog.exportSymbol('proto.api.users.pb.ReadInboxMessageRequest', null, global);
goog.exportSymbol('proto.api.users.pb.ReadInboxMessageResponse', null, global);
goog.exportSymbol('proto.api.users.pb.SendMessageRequest', null, global);
goog.exportSymbol('proto.api.users.pb.SendMessageResponse', null, global);
goog.exportSymbol('proto.api.users.pb.SetupMailboxRequest', null, global);
goog.exportSymbol('proto.api.users.pb.SetupMailboxResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */

proto.api.users.pb.ListThreadsRequest = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.api.users.pb.ListThreadsRequest, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.api.users.pb.ListThreadsRequest.displayName = 'proto.api.users.pb.ListThreadsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.api.users.pb.ListThreadsResponse = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.api.users.pb.ListThreadsResponse.repeatedFields_, null);
};

goog.inherits(proto.api.users.pb.ListThreadsResponse, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.api.users.pb.ListThreadsResponse.displayName = 'proto.api.users.pb.ListThreadsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.api.users.pb.GetThreadRequest = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.api.users.pb.GetThreadRequest, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.api.users.pb.GetThreadRequest.displayName = 'proto.api.users.pb.GetThreadRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.api.users.pb.GetThreadResponse = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.api.users.pb.GetThreadResponse, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.api.users.pb.GetThreadResponse.displayName = 'proto.api.users.pb.GetThreadResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.api.users.pb.SetupMailboxRequest = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.api.users.pb.SetupMailboxRequest, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.api.users.pb.SetupMailboxRequest.displayName = 'proto.api.users.pb.SetupMailboxRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.api.users.pb.SetupMailboxResponse = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.api.users.pb.SetupMailboxResponse, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.api.users.pb.SetupMailboxResponse.displayName = 'proto.api.users.pb.SetupMailboxResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.api.users.pb.Message = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.api.users.pb.Message, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.api.users.pb.Message.displayName = 'proto.api.users.pb.Message';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.api.users.pb.SendMessageRequest = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.api.users.pb.SendMessageRequest, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.api.users.pb.SendMessageRequest.displayName = 'proto.api.users.pb.SendMessageRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.api.users.pb.SendMessageResponse = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.api.users.pb.SendMessageResponse, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.api.users.pb.SendMessageResponse.displayName = 'proto.api.users.pb.SendMessageResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.api.users.pb.ListInboxMessagesRequest = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.api.users.pb.ListInboxMessagesRequest, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.api.users.pb.ListInboxMessagesRequest.displayName = 'proto.api.users.pb.ListInboxMessagesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.api.users.pb.ListInboxMessagesResponse = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.api.users.pb.ListInboxMessagesResponse.repeatedFields_, null);
};

goog.inherits(proto.api.users.pb.ListInboxMessagesResponse, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.api.users.pb.ListInboxMessagesResponse.displayName = 'proto.api.users.pb.ListInboxMessagesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.api.users.pb.ListSentboxMessagesRequest = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.api.users.pb.ListSentboxMessagesRequest, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.api.users.pb.ListSentboxMessagesRequest.displayName = 'proto.api.users.pb.ListSentboxMessagesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.api.users.pb.ListSentboxMessagesResponse = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.api.users.pb.ListSentboxMessagesResponse.repeatedFields_, null);
};

goog.inherits(proto.api.users.pb.ListSentboxMessagesResponse, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.api.users.pb.ListSentboxMessagesResponse.displayName = 'proto.api.users.pb.ListSentboxMessagesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.api.users.pb.ReadInboxMessageRequest = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.api.users.pb.ReadInboxMessageRequest, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.api.users.pb.ReadInboxMessageRequest.displayName = 'proto.api.users.pb.ReadInboxMessageRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.api.users.pb.ReadInboxMessageResponse = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.api.users.pb.ReadInboxMessageResponse, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.api.users.pb.ReadInboxMessageResponse.displayName = 'proto.api.users.pb.ReadInboxMessageResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.api.users.pb.DeleteInboxMessageRequest = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.api.users.pb.DeleteInboxMessageRequest, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.api.users.pb.DeleteInboxMessageRequest.displayName = 'proto.api.users.pb.DeleteInboxMessageRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.api.users.pb.DeleteInboxMessageResponse = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.api.users.pb.DeleteInboxMessageResponse, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.api.users.pb.DeleteInboxMessageResponse.displayName = 'proto.api.users.pb.DeleteInboxMessageResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.api.users.pb.DeleteSentboxMessageRequest = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.api.users.pb.DeleteSentboxMessageRequest, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.api.users.pb.DeleteSentboxMessageRequest.displayName = 'proto.api.users.pb.DeleteSentboxMessageRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.api.users.pb.DeleteSentboxMessageResponse = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.api.users.pb.DeleteSentboxMessageResponse, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.api.users.pb.DeleteSentboxMessageResponse.displayName = 'proto.api.users.pb.DeleteSentboxMessageResponse';
}

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.api.users.pb.ListThreadsRequest.prototype.toObject = function (opt_includeInstance) {
    return proto.api.users.pb.ListThreadsRequest.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.api.users.pb.ListThreadsRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.api.users.pb.ListThreadsRequest.toObject = function (includeInstance, msg) {
    var f,
        obj = {};

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.api.users.pb.ListThreadsRequest}
 */


proto.api.users.pb.ListThreadsRequest.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.api.users.pb.ListThreadsRequest();
  return proto.api.users.pb.ListThreadsRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.api.users.pb.ListThreadsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.api.users.pb.ListThreadsRequest}
 */


proto.api.users.pb.ListThreadsRequest.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.api.users.pb.ListThreadsRequest.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.api.users.pb.ListThreadsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.api.users.pb.ListThreadsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.api.users.pb.ListThreadsRequest.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */


proto.api.users.pb.ListThreadsResponse.repeatedFields_ = [1];

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.api.users.pb.ListThreadsResponse.prototype.toObject = function (opt_includeInstance) {
    return proto.api.users.pb.ListThreadsResponse.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.api.users.pb.ListThreadsResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.api.users.pb.ListThreadsResponse.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      listList: jspb.Message.toObjectList(msg.getListList(), proto.api.users.pb.GetThreadResponse.toObject, includeInstance)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.api.users.pb.ListThreadsResponse}
 */


proto.api.users.pb.ListThreadsResponse.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.api.users.pb.ListThreadsResponse();
  return proto.api.users.pb.ListThreadsResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.api.users.pb.ListThreadsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.api.users.pb.ListThreadsResponse}
 */


proto.api.users.pb.ListThreadsResponse.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value = new proto.api.users.pb.GetThreadResponse();
        reader.readMessage(value, proto.api.users.pb.GetThreadResponse.deserializeBinaryFromReader);
        msg.addList(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.api.users.pb.ListThreadsResponse.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.api.users.pb.ListThreadsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.api.users.pb.ListThreadsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.api.users.pb.ListThreadsResponse.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getListList();

  if (f.length > 0) {
    writer.writeRepeatedMessage(1, f, proto.api.users.pb.GetThreadResponse.serializeBinaryToWriter);
  }
};
/**
 * repeated GetThreadResponse list = 1;
 * @return {!Array<!proto.api.users.pb.GetThreadResponse>}
 */


proto.api.users.pb.ListThreadsResponse.prototype.getListList = function () {
  return (
    /** @type{!Array<!proto.api.users.pb.GetThreadResponse>} */
    jspb.Message.getRepeatedWrapperField(this, proto.api.users.pb.GetThreadResponse, 1)
  );
};
/**
 * @param {!Array<!proto.api.users.pb.GetThreadResponse>} value
 * @return {!proto.api.users.pb.ListThreadsResponse} returns this
*/


proto.api.users.pb.ListThreadsResponse.prototype.setListList = function (value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};
/**
 * @param {!proto.api.users.pb.GetThreadResponse=} opt_value
 * @param {number=} opt_index
 * @return {!proto.api.users.pb.GetThreadResponse}
 */


proto.api.users.pb.ListThreadsResponse.prototype.addList = function (opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.api.users.pb.GetThreadResponse, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.api.users.pb.ListThreadsResponse} returns this
 */


proto.api.users.pb.ListThreadsResponse.prototype.clearListList = function () {
  return this.setListList([]);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.api.users.pb.GetThreadRequest.prototype.toObject = function (opt_includeInstance) {
    return proto.api.users.pb.GetThreadRequest.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.api.users.pb.GetThreadRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.api.users.pb.GetThreadRequest.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      name: jspb.Message.getFieldWithDefault(msg, 1, "")
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.api.users.pb.GetThreadRequest}
 */


proto.api.users.pb.GetThreadRequest.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.api.users.pb.GetThreadRequest();
  return proto.api.users.pb.GetThreadRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.api.users.pb.GetThreadRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.api.users.pb.GetThreadRequest}
 */


proto.api.users.pb.GetThreadRequest.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setName(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.api.users.pb.GetThreadRequest.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.api.users.pb.GetThreadRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.api.users.pb.GetThreadRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.api.users.pb.GetThreadRequest.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getName();

  if (f.length > 0) {
    writer.writeString(1, f);
  }
};
/**
 * optional string name = 1;
 * @return {string}
 */


proto.api.users.pb.GetThreadRequest.prototype.getName = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 1, "")
  );
};
/**
 * @param {string} value
 * @return {!proto.api.users.pb.GetThreadRequest} returns this
 */


proto.api.users.pb.GetThreadRequest.prototype.setName = function (value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.api.users.pb.GetThreadResponse.prototype.toObject = function (opt_includeInstance) {
    return proto.api.users.pb.GetThreadResponse.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.api.users.pb.GetThreadResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.api.users.pb.GetThreadResponse.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      id: msg.getId_asB64(),
      name: jspb.Message.getFieldWithDefault(msg, 2, ""),
      isDb: jspb.Message.getBooleanFieldWithDefault(msg, 3, false)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.api.users.pb.GetThreadResponse}
 */


proto.api.users.pb.GetThreadResponse.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.api.users.pb.GetThreadResponse();
  return proto.api.users.pb.GetThreadResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.api.users.pb.GetThreadResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.api.users.pb.GetThreadResponse}
 */


proto.api.users.pb.GetThreadResponse.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {!Uint8Array} */
        reader.readBytes();
        msg.setId(value);
        break;

      case 2:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setName(value);
        break;

      case 3:
        var value =
        /** @type {boolean} */
        reader.readBool();
        msg.setIsDb(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.api.users.pb.GetThreadResponse.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.api.users.pb.GetThreadResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.api.users.pb.GetThreadResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.api.users.pb.GetThreadResponse.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getId_asU8();

  if (f.length > 0) {
    writer.writeBytes(1, f);
  }

  f = message.getName();

  if (f.length > 0) {
    writer.writeString(2, f);
  }

  f = message.getIsDb();

  if (f) {
    writer.writeBool(3, f);
  }
};
/**
 * optional bytes id = 1;
 * @return {!(string|Uint8Array)}
 */


proto.api.users.pb.GetThreadResponse.prototype.getId = function () {
  return (
    /** @type {!(string|Uint8Array)} */
    jspb.Message.getFieldWithDefault(this, 1, "")
  );
};
/**
 * optional bytes id = 1;
 * This is a type-conversion wrapper around `getId()`
 * @return {string}
 */


proto.api.users.pb.GetThreadResponse.prototype.getId_asB64 = function () {
  return (
    /** @type {string} */
    jspb.Message.bytesAsB64(this.getId())
  );
};
/**
 * optional bytes id = 1;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getId()`
 * @return {!Uint8Array}
 */


proto.api.users.pb.GetThreadResponse.prototype.getId_asU8 = function () {
  return (
    /** @type {!Uint8Array} */
    jspb.Message.bytesAsU8(this.getId())
  );
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.api.users.pb.GetThreadResponse} returns this
 */


proto.api.users.pb.GetThreadResponse.prototype.setId = function (value) {
  return jspb.Message.setProto3BytesField(this, 1, value);
};
/**
 * optional string name = 2;
 * @return {string}
 */


proto.api.users.pb.GetThreadResponse.prototype.getName = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 2, "")
  );
};
/**
 * @param {string} value
 * @return {!proto.api.users.pb.GetThreadResponse} returns this
 */


proto.api.users.pb.GetThreadResponse.prototype.setName = function (value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};
/**
 * optional bool is_db = 3;
 * @return {boolean}
 */


proto.api.users.pb.GetThreadResponse.prototype.getIsDb = function () {
  return (
    /** @type {boolean} */
    jspb.Message.getBooleanFieldWithDefault(this, 3, false)
  );
};
/**
 * @param {boolean} value
 * @return {!proto.api.users.pb.GetThreadResponse} returns this
 */


proto.api.users.pb.GetThreadResponse.prototype.setIsDb = function (value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.api.users.pb.SetupMailboxRequest.prototype.toObject = function (opt_includeInstance) {
    return proto.api.users.pb.SetupMailboxRequest.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.api.users.pb.SetupMailboxRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.api.users.pb.SetupMailboxRequest.toObject = function (includeInstance, msg) {
    var f,
        obj = {};

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.api.users.pb.SetupMailboxRequest}
 */


proto.api.users.pb.SetupMailboxRequest.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.api.users.pb.SetupMailboxRequest();
  return proto.api.users.pb.SetupMailboxRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.api.users.pb.SetupMailboxRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.api.users.pb.SetupMailboxRequest}
 */


proto.api.users.pb.SetupMailboxRequest.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.api.users.pb.SetupMailboxRequest.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.api.users.pb.SetupMailboxRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.api.users.pb.SetupMailboxRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.api.users.pb.SetupMailboxRequest.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.api.users.pb.SetupMailboxResponse.prototype.toObject = function (opt_includeInstance) {
    return proto.api.users.pb.SetupMailboxResponse.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.api.users.pb.SetupMailboxResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.api.users.pb.SetupMailboxResponse.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      mailboxId: msg.getMailboxId_asB64()
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.api.users.pb.SetupMailboxResponse}
 */


proto.api.users.pb.SetupMailboxResponse.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.api.users.pb.SetupMailboxResponse();
  return proto.api.users.pb.SetupMailboxResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.api.users.pb.SetupMailboxResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.api.users.pb.SetupMailboxResponse}
 */


proto.api.users.pb.SetupMailboxResponse.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {!Uint8Array} */
        reader.readBytes();
        msg.setMailboxId(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.api.users.pb.SetupMailboxResponse.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.api.users.pb.SetupMailboxResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.api.users.pb.SetupMailboxResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.api.users.pb.SetupMailboxResponse.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getMailboxId_asU8();

  if (f.length > 0) {
    writer.writeBytes(1, f);
  }
};
/**
 * optional bytes mailbox_id = 1;
 * @return {!(string|Uint8Array)}
 */


proto.api.users.pb.SetupMailboxResponse.prototype.getMailboxId = function () {
  return (
    /** @type {!(string|Uint8Array)} */
    jspb.Message.getFieldWithDefault(this, 1, "")
  );
};
/**
 * optional bytes mailbox_id = 1;
 * This is a type-conversion wrapper around `getMailboxId()`
 * @return {string}
 */


proto.api.users.pb.SetupMailboxResponse.prototype.getMailboxId_asB64 = function () {
  return (
    /** @type {string} */
    jspb.Message.bytesAsB64(this.getMailboxId())
  );
};
/**
 * optional bytes mailbox_id = 1;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getMailboxId()`
 * @return {!Uint8Array}
 */


proto.api.users.pb.SetupMailboxResponse.prototype.getMailboxId_asU8 = function () {
  return (
    /** @type {!Uint8Array} */
    jspb.Message.bytesAsU8(this.getMailboxId())
  );
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.api.users.pb.SetupMailboxResponse} returns this
 */


proto.api.users.pb.SetupMailboxResponse.prototype.setMailboxId = function (value) {
  return jspb.Message.setProto3BytesField(this, 1, value);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.api.users.pb.Message.prototype.toObject = function (opt_includeInstance) {
    return proto.api.users.pb.Message.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.api.users.pb.Message} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.api.users.pb.Message.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      id: jspb.Message.getFieldWithDefault(msg, 1, ""),
      from: jspb.Message.getFieldWithDefault(msg, 2, ""),
      to: jspb.Message.getFieldWithDefault(msg, 3, ""),
      body: msg.getBody_asB64(),
      signature: msg.getSignature_asB64(),
      createdAt: jspb.Message.getFieldWithDefault(msg, 6, 0),
      readAt: jspb.Message.getFieldWithDefault(msg, 7, 0)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.api.users.pb.Message}
 */


proto.api.users.pb.Message.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.api.users.pb.Message();
  return proto.api.users.pb.Message.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.api.users.pb.Message} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.api.users.pb.Message}
 */


proto.api.users.pb.Message.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setId(value);
        break;

      case 2:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setFrom(value);
        break;

      case 3:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setTo(value);
        break;

      case 4:
        var value =
        /** @type {!Uint8Array} */
        reader.readBytes();
        msg.setBody(value);
        break;

      case 5:
        var value =
        /** @type {!Uint8Array} */
        reader.readBytes();
        msg.setSignature(value);
        break;

      case 6:
        var value =
        /** @type {number} */
        reader.readInt64();
        msg.setCreatedAt(value);
        break;

      case 7:
        var value =
        /** @type {number} */
        reader.readInt64();
        msg.setReadAt(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.api.users.pb.Message.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.api.users.pb.Message.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.api.users.pb.Message} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.api.users.pb.Message.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getId();

  if (f.length > 0) {
    writer.writeString(1, f);
  }

  f = message.getFrom();

  if (f.length > 0) {
    writer.writeString(2, f);
  }

  f = message.getTo();

  if (f.length > 0) {
    writer.writeString(3, f);
  }

  f = message.getBody_asU8();

  if (f.length > 0) {
    writer.writeBytes(4, f);
  }

  f = message.getSignature_asU8();

  if (f.length > 0) {
    writer.writeBytes(5, f);
  }

  f = message.getCreatedAt();

  if (f !== 0) {
    writer.writeInt64(6, f);
  }

  f = message.getReadAt();

  if (f !== 0) {
    writer.writeInt64(7, f);
  }
};
/**
 * optional string id = 1;
 * @return {string}
 */


proto.api.users.pb.Message.prototype.getId = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 1, "")
  );
};
/**
 * @param {string} value
 * @return {!proto.api.users.pb.Message} returns this
 */


proto.api.users.pb.Message.prototype.setId = function (value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string from = 2;
 * @return {string}
 */


proto.api.users.pb.Message.prototype.getFrom = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 2, "")
  );
};
/**
 * @param {string} value
 * @return {!proto.api.users.pb.Message} returns this
 */


proto.api.users.pb.Message.prototype.setFrom = function (value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string to = 3;
 * @return {string}
 */


proto.api.users.pb.Message.prototype.getTo = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 3, "")
  );
};
/**
 * @param {string} value
 * @return {!proto.api.users.pb.Message} returns this
 */


proto.api.users.pb.Message.prototype.setTo = function (value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};
/**
 * optional bytes body = 4;
 * @return {!(string|Uint8Array)}
 */


proto.api.users.pb.Message.prototype.getBody = function () {
  return (
    /** @type {!(string|Uint8Array)} */
    jspb.Message.getFieldWithDefault(this, 4, "")
  );
};
/**
 * optional bytes body = 4;
 * This is a type-conversion wrapper around `getBody()`
 * @return {string}
 */


proto.api.users.pb.Message.prototype.getBody_asB64 = function () {
  return (
    /** @type {string} */
    jspb.Message.bytesAsB64(this.getBody())
  );
};
/**
 * optional bytes body = 4;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getBody()`
 * @return {!Uint8Array}
 */


proto.api.users.pb.Message.prototype.getBody_asU8 = function () {
  return (
    /** @type {!Uint8Array} */
    jspb.Message.bytesAsU8(this.getBody())
  );
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.api.users.pb.Message} returns this
 */


proto.api.users.pb.Message.prototype.setBody = function (value) {
  return jspb.Message.setProto3BytesField(this, 4, value);
};
/**
 * optional bytes signature = 5;
 * @return {!(string|Uint8Array)}
 */


proto.api.users.pb.Message.prototype.getSignature = function () {
  return (
    /** @type {!(string|Uint8Array)} */
    jspb.Message.getFieldWithDefault(this, 5, "")
  );
};
/**
 * optional bytes signature = 5;
 * This is a type-conversion wrapper around `getSignature()`
 * @return {string}
 */


proto.api.users.pb.Message.prototype.getSignature_asB64 = function () {
  return (
    /** @type {string} */
    jspb.Message.bytesAsB64(this.getSignature())
  );
};
/**
 * optional bytes signature = 5;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getSignature()`
 * @return {!Uint8Array}
 */


proto.api.users.pb.Message.prototype.getSignature_asU8 = function () {
  return (
    /** @type {!Uint8Array} */
    jspb.Message.bytesAsU8(this.getSignature())
  );
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.api.users.pb.Message} returns this
 */


proto.api.users.pb.Message.prototype.setSignature = function (value) {
  return jspb.Message.setProto3BytesField(this, 5, value);
};
/**
 * optional int64 created_at = 6;
 * @return {number}
 */


proto.api.users.pb.Message.prototype.getCreatedAt = function () {
  return (
    /** @type {number} */
    jspb.Message.getFieldWithDefault(this, 6, 0)
  );
};
/**
 * @param {number} value
 * @return {!proto.api.users.pb.Message} returns this
 */


proto.api.users.pb.Message.prototype.setCreatedAt = function (value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};
/**
 * optional int64 read_at = 7;
 * @return {number}
 */


proto.api.users.pb.Message.prototype.getReadAt = function () {
  return (
    /** @type {number} */
    jspb.Message.getFieldWithDefault(this, 7, 0)
  );
};
/**
 * @param {number} value
 * @return {!proto.api.users.pb.Message} returns this
 */


proto.api.users.pb.Message.prototype.setReadAt = function (value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.api.users.pb.SendMessageRequest.prototype.toObject = function (opt_includeInstance) {
    return proto.api.users.pb.SendMessageRequest.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.api.users.pb.SendMessageRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.api.users.pb.SendMessageRequest.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      to: jspb.Message.getFieldWithDefault(msg, 1, ""),
      toBody: msg.getToBody_asB64(),
      toSignature: msg.getToSignature_asB64(),
      fromBody: msg.getFromBody_asB64(),
      fromSignature: msg.getFromSignature_asB64()
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.api.users.pb.SendMessageRequest}
 */


proto.api.users.pb.SendMessageRequest.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.api.users.pb.SendMessageRequest();
  return proto.api.users.pb.SendMessageRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.api.users.pb.SendMessageRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.api.users.pb.SendMessageRequest}
 */


proto.api.users.pb.SendMessageRequest.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setTo(value);
        break;

      case 2:
        var value =
        /** @type {!Uint8Array} */
        reader.readBytes();
        msg.setToBody(value);
        break;

      case 3:
        var value =
        /** @type {!Uint8Array} */
        reader.readBytes();
        msg.setToSignature(value);
        break;

      case 4:
        var value =
        /** @type {!Uint8Array} */
        reader.readBytes();
        msg.setFromBody(value);
        break;

      case 5:
        var value =
        /** @type {!Uint8Array} */
        reader.readBytes();
        msg.setFromSignature(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.api.users.pb.SendMessageRequest.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.api.users.pb.SendMessageRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.api.users.pb.SendMessageRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.api.users.pb.SendMessageRequest.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getTo();

  if (f.length > 0) {
    writer.writeString(1, f);
  }

  f = message.getToBody_asU8();

  if (f.length > 0) {
    writer.writeBytes(2, f);
  }

  f = message.getToSignature_asU8();

  if (f.length > 0) {
    writer.writeBytes(3, f);
  }

  f = message.getFromBody_asU8();

  if (f.length > 0) {
    writer.writeBytes(4, f);
  }

  f = message.getFromSignature_asU8();

  if (f.length > 0) {
    writer.writeBytes(5, f);
  }
};
/**
 * optional string to = 1;
 * @return {string}
 */


proto.api.users.pb.SendMessageRequest.prototype.getTo = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 1, "")
  );
};
/**
 * @param {string} value
 * @return {!proto.api.users.pb.SendMessageRequest} returns this
 */


proto.api.users.pb.SendMessageRequest.prototype.setTo = function (value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};
/**
 * optional bytes to_body = 2;
 * @return {!(string|Uint8Array)}
 */


proto.api.users.pb.SendMessageRequest.prototype.getToBody = function () {
  return (
    /** @type {!(string|Uint8Array)} */
    jspb.Message.getFieldWithDefault(this, 2, "")
  );
};
/**
 * optional bytes to_body = 2;
 * This is a type-conversion wrapper around `getToBody()`
 * @return {string}
 */


proto.api.users.pb.SendMessageRequest.prototype.getToBody_asB64 = function () {
  return (
    /** @type {string} */
    jspb.Message.bytesAsB64(this.getToBody())
  );
};
/**
 * optional bytes to_body = 2;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getToBody()`
 * @return {!Uint8Array}
 */


proto.api.users.pb.SendMessageRequest.prototype.getToBody_asU8 = function () {
  return (
    /** @type {!Uint8Array} */
    jspb.Message.bytesAsU8(this.getToBody())
  );
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.api.users.pb.SendMessageRequest} returns this
 */


proto.api.users.pb.SendMessageRequest.prototype.setToBody = function (value) {
  return jspb.Message.setProto3BytesField(this, 2, value);
};
/**
 * optional bytes to_signature = 3;
 * @return {!(string|Uint8Array)}
 */


proto.api.users.pb.SendMessageRequest.prototype.getToSignature = function () {
  return (
    /** @type {!(string|Uint8Array)} */
    jspb.Message.getFieldWithDefault(this, 3, "")
  );
};
/**
 * optional bytes to_signature = 3;
 * This is a type-conversion wrapper around `getToSignature()`
 * @return {string}
 */


proto.api.users.pb.SendMessageRequest.prototype.getToSignature_asB64 = function () {
  return (
    /** @type {string} */
    jspb.Message.bytesAsB64(this.getToSignature())
  );
};
/**
 * optional bytes to_signature = 3;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getToSignature()`
 * @return {!Uint8Array}
 */


proto.api.users.pb.SendMessageRequest.prototype.getToSignature_asU8 = function () {
  return (
    /** @type {!Uint8Array} */
    jspb.Message.bytesAsU8(this.getToSignature())
  );
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.api.users.pb.SendMessageRequest} returns this
 */


proto.api.users.pb.SendMessageRequest.prototype.setToSignature = function (value) {
  return jspb.Message.setProto3BytesField(this, 3, value);
};
/**
 * optional bytes from_body = 4;
 * @return {!(string|Uint8Array)}
 */


proto.api.users.pb.SendMessageRequest.prototype.getFromBody = function () {
  return (
    /** @type {!(string|Uint8Array)} */
    jspb.Message.getFieldWithDefault(this, 4, "")
  );
};
/**
 * optional bytes from_body = 4;
 * This is a type-conversion wrapper around `getFromBody()`
 * @return {string}
 */


proto.api.users.pb.SendMessageRequest.prototype.getFromBody_asB64 = function () {
  return (
    /** @type {string} */
    jspb.Message.bytesAsB64(this.getFromBody())
  );
};
/**
 * optional bytes from_body = 4;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getFromBody()`
 * @return {!Uint8Array}
 */


proto.api.users.pb.SendMessageRequest.prototype.getFromBody_asU8 = function () {
  return (
    /** @type {!Uint8Array} */
    jspb.Message.bytesAsU8(this.getFromBody())
  );
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.api.users.pb.SendMessageRequest} returns this
 */


proto.api.users.pb.SendMessageRequest.prototype.setFromBody = function (value) {
  return jspb.Message.setProto3BytesField(this, 4, value);
};
/**
 * optional bytes from_signature = 5;
 * @return {!(string|Uint8Array)}
 */


proto.api.users.pb.SendMessageRequest.prototype.getFromSignature = function () {
  return (
    /** @type {!(string|Uint8Array)} */
    jspb.Message.getFieldWithDefault(this, 5, "")
  );
};
/**
 * optional bytes from_signature = 5;
 * This is a type-conversion wrapper around `getFromSignature()`
 * @return {string}
 */


proto.api.users.pb.SendMessageRequest.prototype.getFromSignature_asB64 = function () {
  return (
    /** @type {string} */
    jspb.Message.bytesAsB64(this.getFromSignature())
  );
};
/**
 * optional bytes from_signature = 5;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getFromSignature()`
 * @return {!Uint8Array}
 */


proto.api.users.pb.SendMessageRequest.prototype.getFromSignature_asU8 = function () {
  return (
    /** @type {!Uint8Array} */
    jspb.Message.bytesAsU8(this.getFromSignature())
  );
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.api.users.pb.SendMessageRequest} returns this
 */


proto.api.users.pb.SendMessageRequest.prototype.setFromSignature = function (value) {
  return jspb.Message.setProto3BytesField(this, 5, value);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.api.users.pb.SendMessageResponse.prototype.toObject = function (opt_includeInstance) {
    return proto.api.users.pb.SendMessageResponse.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.api.users.pb.SendMessageResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.api.users.pb.SendMessageResponse.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      id: jspb.Message.getFieldWithDefault(msg, 1, ""),
      createdAt: jspb.Message.getFieldWithDefault(msg, 2, 0)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.api.users.pb.SendMessageResponse}
 */


proto.api.users.pb.SendMessageResponse.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.api.users.pb.SendMessageResponse();
  return proto.api.users.pb.SendMessageResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.api.users.pb.SendMessageResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.api.users.pb.SendMessageResponse}
 */


proto.api.users.pb.SendMessageResponse.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setId(value);
        break;

      case 2:
        var value =
        /** @type {number} */
        reader.readInt64();
        msg.setCreatedAt(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.api.users.pb.SendMessageResponse.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.api.users.pb.SendMessageResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.api.users.pb.SendMessageResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.api.users.pb.SendMessageResponse.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getId();

  if (f.length > 0) {
    writer.writeString(1, f);
  }

  f = message.getCreatedAt();

  if (f !== 0) {
    writer.writeInt64(2, f);
  }
};
/**
 * optional string id = 1;
 * @return {string}
 */


proto.api.users.pb.SendMessageResponse.prototype.getId = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 1, "")
  );
};
/**
 * @param {string} value
 * @return {!proto.api.users.pb.SendMessageResponse} returns this
 */


proto.api.users.pb.SendMessageResponse.prototype.setId = function (value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};
/**
 * optional int64 created_at = 2;
 * @return {number}
 */


proto.api.users.pb.SendMessageResponse.prototype.getCreatedAt = function () {
  return (
    /** @type {number} */
    jspb.Message.getFieldWithDefault(this, 2, 0)
  );
};
/**
 * @param {number} value
 * @return {!proto.api.users.pb.SendMessageResponse} returns this
 */


proto.api.users.pb.SendMessageResponse.prototype.setCreatedAt = function (value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.api.users.pb.ListInboxMessagesRequest.prototype.toObject = function (opt_includeInstance) {
    return proto.api.users.pb.ListInboxMessagesRequest.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.api.users.pb.ListInboxMessagesRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.api.users.pb.ListInboxMessagesRequest.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      seek: jspb.Message.getFieldWithDefault(msg, 1, ""),
      limit: jspb.Message.getFieldWithDefault(msg, 2, 0),
      ascending: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
      status: jspb.Message.getFieldWithDefault(msg, 4, 0)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.api.users.pb.ListInboxMessagesRequest}
 */


proto.api.users.pb.ListInboxMessagesRequest.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.api.users.pb.ListInboxMessagesRequest();
  return proto.api.users.pb.ListInboxMessagesRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.api.users.pb.ListInboxMessagesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.api.users.pb.ListInboxMessagesRequest}
 */


proto.api.users.pb.ListInboxMessagesRequest.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setSeek(value);
        break;

      case 2:
        var value =
        /** @type {number} */
        reader.readInt64();
        msg.setLimit(value);
        break;

      case 3:
        var value =
        /** @type {boolean} */
        reader.readBool();
        msg.setAscending(value);
        break;

      case 4:
        var value =
        /** @type {!proto.api.users.pb.ListInboxMessagesRequest.Status} */
        reader.readEnum();
        msg.setStatus(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.api.users.pb.ListInboxMessagesRequest.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.api.users.pb.ListInboxMessagesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.api.users.pb.ListInboxMessagesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.api.users.pb.ListInboxMessagesRequest.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getSeek();

  if (f.length > 0) {
    writer.writeString(1, f);
  }

  f = message.getLimit();

  if (f !== 0) {
    writer.writeInt64(2, f);
  }

  f = message.getAscending();

  if (f) {
    writer.writeBool(3, f);
  }

  f = message.getStatus();

  if (f !== 0.0) {
    writer.writeEnum(4, f);
  }
};
/**
 * @enum {number}
 */


proto.api.users.pb.ListInboxMessagesRequest.Status = {
  STATUS_UNSPECIFIED: 0,
  STATUS_ALL: 1,
  STATUS_READ: 2,
  STATUS_UNREAD: 3
};
/**
 * optional string seek = 1;
 * @return {string}
 */

proto.api.users.pb.ListInboxMessagesRequest.prototype.getSeek = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 1, "")
  );
};
/**
 * @param {string} value
 * @return {!proto.api.users.pb.ListInboxMessagesRequest} returns this
 */


proto.api.users.pb.ListInboxMessagesRequest.prototype.setSeek = function (value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};
/**
 * optional int64 limit = 2;
 * @return {number}
 */


proto.api.users.pb.ListInboxMessagesRequest.prototype.getLimit = function () {
  return (
    /** @type {number} */
    jspb.Message.getFieldWithDefault(this, 2, 0)
  );
};
/**
 * @param {number} value
 * @return {!proto.api.users.pb.ListInboxMessagesRequest} returns this
 */


proto.api.users.pb.ListInboxMessagesRequest.prototype.setLimit = function (value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};
/**
 * optional bool ascending = 3;
 * @return {boolean}
 */


proto.api.users.pb.ListInboxMessagesRequest.prototype.getAscending = function () {
  return (
    /** @type {boolean} */
    jspb.Message.getBooleanFieldWithDefault(this, 3, false)
  );
};
/**
 * @param {boolean} value
 * @return {!proto.api.users.pb.ListInboxMessagesRequest} returns this
 */


proto.api.users.pb.ListInboxMessagesRequest.prototype.setAscending = function (value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};
/**
 * optional Status status = 4;
 * @return {!proto.api.users.pb.ListInboxMessagesRequest.Status}
 */


proto.api.users.pb.ListInboxMessagesRequest.prototype.getStatus = function () {
  return (
    /** @type {!proto.api.users.pb.ListInboxMessagesRequest.Status} */
    jspb.Message.getFieldWithDefault(this, 4, 0)
  );
};
/**
 * @param {!proto.api.users.pb.ListInboxMessagesRequest.Status} value
 * @return {!proto.api.users.pb.ListInboxMessagesRequest} returns this
 */


proto.api.users.pb.ListInboxMessagesRequest.prototype.setStatus = function (value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */


proto.api.users.pb.ListInboxMessagesResponse.repeatedFields_ = [1];

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.api.users.pb.ListInboxMessagesResponse.prototype.toObject = function (opt_includeInstance) {
    return proto.api.users.pb.ListInboxMessagesResponse.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.api.users.pb.ListInboxMessagesResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.api.users.pb.ListInboxMessagesResponse.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      messagesList: jspb.Message.toObjectList(msg.getMessagesList(), proto.api.users.pb.Message.toObject, includeInstance)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.api.users.pb.ListInboxMessagesResponse}
 */


proto.api.users.pb.ListInboxMessagesResponse.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.api.users.pb.ListInboxMessagesResponse();
  return proto.api.users.pb.ListInboxMessagesResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.api.users.pb.ListInboxMessagesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.api.users.pb.ListInboxMessagesResponse}
 */


proto.api.users.pb.ListInboxMessagesResponse.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value = new proto.api.users.pb.Message();
        reader.readMessage(value, proto.api.users.pb.Message.deserializeBinaryFromReader);
        msg.addMessages(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.api.users.pb.ListInboxMessagesResponse.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.api.users.pb.ListInboxMessagesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.api.users.pb.ListInboxMessagesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.api.users.pb.ListInboxMessagesResponse.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getMessagesList();

  if (f.length > 0) {
    writer.writeRepeatedMessage(1, f, proto.api.users.pb.Message.serializeBinaryToWriter);
  }
};
/**
 * repeated Message messages = 1;
 * @return {!Array<!proto.api.users.pb.Message>}
 */


proto.api.users.pb.ListInboxMessagesResponse.prototype.getMessagesList = function () {
  return (
    /** @type{!Array<!proto.api.users.pb.Message>} */
    jspb.Message.getRepeatedWrapperField(this, proto.api.users.pb.Message, 1)
  );
};
/**
 * @param {!Array<!proto.api.users.pb.Message>} value
 * @return {!proto.api.users.pb.ListInboxMessagesResponse} returns this
*/


proto.api.users.pb.ListInboxMessagesResponse.prototype.setMessagesList = function (value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};
/**
 * @param {!proto.api.users.pb.Message=} opt_value
 * @param {number=} opt_index
 * @return {!proto.api.users.pb.Message}
 */


proto.api.users.pb.ListInboxMessagesResponse.prototype.addMessages = function (opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.api.users.pb.Message, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.api.users.pb.ListInboxMessagesResponse} returns this
 */


proto.api.users.pb.ListInboxMessagesResponse.prototype.clearMessagesList = function () {
  return this.setMessagesList([]);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.api.users.pb.ListSentboxMessagesRequest.prototype.toObject = function (opt_includeInstance) {
    return proto.api.users.pb.ListSentboxMessagesRequest.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.api.users.pb.ListSentboxMessagesRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.api.users.pb.ListSentboxMessagesRequest.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      seek: jspb.Message.getFieldWithDefault(msg, 1, ""),
      limit: jspb.Message.getFieldWithDefault(msg, 2, 0),
      ascending: jspb.Message.getBooleanFieldWithDefault(msg, 3, false)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.api.users.pb.ListSentboxMessagesRequest}
 */


proto.api.users.pb.ListSentboxMessagesRequest.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.api.users.pb.ListSentboxMessagesRequest();
  return proto.api.users.pb.ListSentboxMessagesRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.api.users.pb.ListSentboxMessagesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.api.users.pb.ListSentboxMessagesRequest}
 */


proto.api.users.pb.ListSentboxMessagesRequest.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setSeek(value);
        break;

      case 2:
        var value =
        /** @type {number} */
        reader.readInt64();
        msg.setLimit(value);
        break;

      case 3:
        var value =
        /** @type {boolean} */
        reader.readBool();
        msg.setAscending(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.api.users.pb.ListSentboxMessagesRequest.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.api.users.pb.ListSentboxMessagesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.api.users.pb.ListSentboxMessagesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.api.users.pb.ListSentboxMessagesRequest.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getSeek();

  if (f.length > 0) {
    writer.writeString(1, f);
  }

  f = message.getLimit();

  if (f !== 0) {
    writer.writeInt64(2, f);
  }

  f = message.getAscending();

  if (f) {
    writer.writeBool(3, f);
  }
};
/**
 * optional string seek = 1;
 * @return {string}
 */


proto.api.users.pb.ListSentboxMessagesRequest.prototype.getSeek = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 1, "")
  );
};
/**
 * @param {string} value
 * @return {!proto.api.users.pb.ListSentboxMessagesRequest} returns this
 */


proto.api.users.pb.ListSentboxMessagesRequest.prototype.setSeek = function (value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};
/**
 * optional int64 limit = 2;
 * @return {number}
 */


proto.api.users.pb.ListSentboxMessagesRequest.prototype.getLimit = function () {
  return (
    /** @type {number} */
    jspb.Message.getFieldWithDefault(this, 2, 0)
  );
};
/**
 * @param {number} value
 * @return {!proto.api.users.pb.ListSentboxMessagesRequest} returns this
 */


proto.api.users.pb.ListSentboxMessagesRequest.prototype.setLimit = function (value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};
/**
 * optional bool ascending = 3;
 * @return {boolean}
 */


proto.api.users.pb.ListSentboxMessagesRequest.prototype.getAscending = function () {
  return (
    /** @type {boolean} */
    jspb.Message.getBooleanFieldWithDefault(this, 3, false)
  );
};
/**
 * @param {boolean} value
 * @return {!proto.api.users.pb.ListSentboxMessagesRequest} returns this
 */


proto.api.users.pb.ListSentboxMessagesRequest.prototype.setAscending = function (value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */


proto.api.users.pb.ListSentboxMessagesResponse.repeatedFields_ = [1];

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.api.users.pb.ListSentboxMessagesResponse.prototype.toObject = function (opt_includeInstance) {
    return proto.api.users.pb.ListSentboxMessagesResponse.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.api.users.pb.ListSentboxMessagesResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.api.users.pb.ListSentboxMessagesResponse.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      messagesList: jspb.Message.toObjectList(msg.getMessagesList(), proto.api.users.pb.Message.toObject, includeInstance)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.api.users.pb.ListSentboxMessagesResponse}
 */


proto.api.users.pb.ListSentboxMessagesResponse.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.api.users.pb.ListSentboxMessagesResponse();
  return proto.api.users.pb.ListSentboxMessagesResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.api.users.pb.ListSentboxMessagesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.api.users.pb.ListSentboxMessagesResponse}
 */


proto.api.users.pb.ListSentboxMessagesResponse.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value = new proto.api.users.pb.Message();
        reader.readMessage(value, proto.api.users.pb.Message.deserializeBinaryFromReader);
        msg.addMessages(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.api.users.pb.ListSentboxMessagesResponse.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.api.users.pb.ListSentboxMessagesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.api.users.pb.ListSentboxMessagesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.api.users.pb.ListSentboxMessagesResponse.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getMessagesList();

  if (f.length > 0) {
    writer.writeRepeatedMessage(1, f, proto.api.users.pb.Message.serializeBinaryToWriter);
  }
};
/**
 * repeated Message messages = 1;
 * @return {!Array<!proto.api.users.pb.Message>}
 */


proto.api.users.pb.ListSentboxMessagesResponse.prototype.getMessagesList = function () {
  return (
    /** @type{!Array<!proto.api.users.pb.Message>} */
    jspb.Message.getRepeatedWrapperField(this, proto.api.users.pb.Message, 1)
  );
};
/**
 * @param {!Array<!proto.api.users.pb.Message>} value
 * @return {!proto.api.users.pb.ListSentboxMessagesResponse} returns this
*/


proto.api.users.pb.ListSentboxMessagesResponse.prototype.setMessagesList = function (value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};
/**
 * @param {!proto.api.users.pb.Message=} opt_value
 * @param {number=} opt_index
 * @return {!proto.api.users.pb.Message}
 */


proto.api.users.pb.ListSentboxMessagesResponse.prototype.addMessages = function (opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.api.users.pb.Message, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.api.users.pb.ListSentboxMessagesResponse} returns this
 */


proto.api.users.pb.ListSentboxMessagesResponse.prototype.clearMessagesList = function () {
  return this.setMessagesList([]);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.api.users.pb.ReadInboxMessageRequest.prototype.toObject = function (opt_includeInstance) {
    return proto.api.users.pb.ReadInboxMessageRequest.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.api.users.pb.ReadInboxMessageRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.api.users.pb.ReadInboxMessageRequest.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      id: jspb.Message.getFieldWithDefault(msg, 1, "")
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.api.users.pb.ReadInboxMessageRequest}
 */


proto.api.users.pb.ReadInboxMessageRequest.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.api.users.pb.ReadInboxMessageRequest();
  return proto.api.users.pb.ReadInboxMessageRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.api.users.pb.ReadInboxMessageRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.api.users.pb.ReadInboxMessageRequest}
 */


proto.api.users.pb.ReadInboxMessageRequest.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setId(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.api.users.pb.ReadInboxMessageRequest.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.api.users.pb.ReadInboxMessageRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.api.users.pb.ReadInboxMessageRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.api.users.pb.ReadInboxMessageRequest.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getId();

  if (f.length > 0) {
    writer.writeString(1, f);
  }
};
/**
 * optional string id = 1;
 * @return {string}
 */


proto.api.users.pb.ReadInboxMessageRequest.prototype.getId = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 1, "")
  );
};
/**
 * @param {string} value
 * @return {!proto.api.users.pb.ReadInboxMessageRequest} returns this
 */


proto.api.users.pb.ReadInboxMessageRequest.prototype.setId = function (value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.api.users.pb.ReadInboxMessageResponse.prototype.toObject = function (opt_includeInstance) {
    return proto.api.users.pb.ReadInboxMessageResponse.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.api.users.pb.ReadInboxMessageResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.api.users.pb.ReadInboxMessageResponse.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      readAt: jspb.Message.getFieldWithDefault(msg, 1, 0)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.api.users.pb.ReadInboxMessageResponse}
 */


proto.api.users.pb.ReadInboxMessageResponse.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.api.users.pb.ReadInboxMessageResponse();
  return proto.api.users.pb.ReadInboxMessageResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.api.users.pb.ReadInboxMessageResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.api.users.pb.ReadInboxMessageResponse}
 */


proto.api.users.pb.ReadInboxMessageResponse.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {number} */
        reader.readInt64();
        msg.setReadAt(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.api.users.pb.ReadInboxMessageResponse.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.api.users.pb.ReadInboxMessageResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.api.users.pb.ReadInboxMessageResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.api.users.pb.ReadInboxMessageResponse.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getReadAt();

  if (f !== 0) {
    writer.writeInt64(1, f);
  }
};
/**
 * optional int64 read_at = 1;
 * @return {number}
 */


proto.api.users.pb.ReadInboxMessageResponse.prototype.getReadAt = function () {
  return (
    /** @type {number} */
    jspb.Message.getFieldWithDefault(this, 1, 0)
  );
};
/**
 * @param {number} value
 * @return {!proto.api.users.pb.ReadInboxMessageResponse} returns this
 */


proto.api.users.pb.ReadInboxMessageResponse.prototype.setReadAt = function (value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.api.users.pb.DeleteInboxMessageRequest.prototype.toObject = function (opt_includeInstance) {
    return proto.api.users.pb.DeleteInboxMessageRequest.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.api.users.pb.DeleteInboxMessageRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.api.users.pb.DeleteInboxMessageRequest.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      id: jspb.Message.getFieldWithDefault(msg, 1, "")
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.api.users.pb.DeleteInboxMessageRequest}
 */


proto.api.users.pb.DeleteInboxMessageRequest.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.api.users.pb.DeleteInboxMessageRequest();
  return proto.api.users.pb.DeleteInboxMessageRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.api.users.pb.DeleteInboxMessageRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.api.users.pb.DeleteInboxMessageRequest}
 */


proto.api.users.pb.DeleteInboxMessageRequest.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setId(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.api.users.pb.DeleteInboxMessageRequest.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.api.users.pb.DeleteInboxMessageRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.api.users.pb.DeleteInboxMessageRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.api.users.pb.DeleteInboxMessageRequest.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getId();

  if (f.length > 0) {
    writer.writeString(1, f);
  }
};
/**
 * optional string id = 1;
 * @return {string}
 */


proto.api.users.pb.DeleteInboxMessageRequest.prototype.getId = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 1, "")
  );
};
/**
 * @param {string} value
 * @return {!proto.api.users.pb.DeleteInboxMessageRequest} returns this
 */


proto.api.users.pb.DeleteInboxMessageRequest.prototype.setId = function (value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.api.users.pb.DeleteInboxMessageResponse.prototype.toObject = function (opt_includeInstance) {
    return proto.api.users.pb.DeleteInboxMessageResponse.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.api.users.pb.DeleteInboxMessageResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.api.users.pb.DeleteInboxMessageResponse.toObject = function (includeInstance, msg) {
    var f,
        obj = {};

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.api.users.pb.DeleteInboxMessageResponse}
 */


proto.api.users.pb.DeleteInboxMessageResponse.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.api.users.pb.DeleteInboxMessageResponse();
  return proto.api.users.pb.DeleteInboxMessageResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.api.users.pb.DeleteInboxMessageResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.api.users.pb.DeleteInboxMessageResponse}
 */


proto.api.users.pb.DeleteInboxMessageResponse.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.api.users.pb.DeleteInboxMessageResponse.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.api.users.pb.DeleteInboxMessageResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.api.users.pb.DeleteInboxMessageResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.api.users.pb.DeleteInboxMessageResponse.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.api.users.pb.DeleteSentboxMessageRequest.prototype.toObject = function (opt_includeInstance) {
    return proto.api.users.pb.DeleteSentboxMessageRequest.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.api.users.pb.DeleteSentboxMessageRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.api.users.pb.DeleteSentboxMessageRequest.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      id: jspb.Message.getFieldWithDefault(msg, 1, "")
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.api.users.pb.DeleteSentboxMessageRequest}
 */


proto.api.users.pb.DeleteSentboxMessageRequest.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.api.users.pb.DeleteSentboxMessageRequest();
  return proto.api.users.pb.DeleteSentboxMessageRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.api.users.pb.DeleteSentboxMessageRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.api.users.pb.DeleteSentboxMessageRequest}
 */


proto.api.users.pb.DeleteSentboxMessageRequest.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setId(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.api.users.pb.DeleteSentboxMessageRequest.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.api.users.pb.DeleteSentboxMessageRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.api.users.pb.DeleteSentboxMessageRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.api.users.pb.DeleteSentboxMessageRequest.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getId();

  if (f.length > 0) {
    writer.writeString(1, f);
  }
};
/**
 * optional string id = 1;
 * @return {string}
 */


proto.api.users.pb.DeleteSentboxMessageRequest.prototype.getId = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 1, "")
  );
};
/**
 * @param {string} value
 * @return {!proto.api.users.pb.DeleteSentboxMessageRequest} returns this
 */


proto.api.users.pb.DeleteSentboxMessageRequest.prototype.setId = function (value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.api.users.pb.DeleteSentboxMessageResponse.prototype.toObject = function (opt_includeInstance) {
    return proto.api.users.pb.DeleteSentboxMessageResponse.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.api.users.pb.DeleteSentboxMessageResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.api.users.pb.DeleteSentboxMessageResponse.toObject = function (includeInstance, msg) {
    var f,
        obj = {};

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.api.users.pb.DeleteSentboxMessageResponse}
 */


proto.api.users.pb.DeleteSentboxMessageResponse.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.api.users.pb.DeleteSentboxMessageResponse();
  return proto.api.users.pb.DeleteSentboxMessageResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.api.users.pb.DeleteSentboxMessageResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.api.users.pb.DeleteSentboxMessageResponse}
 */


proto.api.users.pb.DeleteSentboxMessageResponse.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.api.users.pb.DeleteSentboxMessageResponse.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.api.users.pb.DeleteSentboxMessageResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.api.users.pb.DeleteSentboxMessageResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.api.users.pb.DeleteSentboxMessageResponse.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
};

goog.object.extend(exports, proto.api.users.pb);